// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zTSSw","toggle":"styles_toggle__1kcQ5","preview":"styles_preview__2AQsc"};